/**
 * AreaRole - Classe OOP para manipulação de unidades de área
 *
 * Implementa os 4 pilares via composição dos módulos separados.
 * Para uso funcional, importe diretamente dos pilares:
 *
 * @example
 * // OOP
 * import { areaRole } from '@attrx/role-morphic/area';
 * areaRole.convert('hectare', 'acre', 1);
 *
 * // Funcional
 * import { convertArea } from '@attrx/role-morphic/area/convert';
 * convertArea('hectare', 'acre', 1);
 */

import { SimpleRole, type SimpleValidationConfig } from "../../contracts";
import { AREA_UNITS, AREA_ALIASES } from "./constants";

// =============================================================================
// AREA ROLE CLASS
// =============================================================================

export class AreaRole extends SimpleRole {
  readonly name = "area";
  readonly base = "square_meter";
  readonly units = AREA_UNITS;
  readonly aliases = AREA_ALIASES;

  readonly validation: SimpleValidationConfig = {
    min: 0,
    minError: "Area cannot be negative",
  };
}

// =============================================================================
// SINGLETON INSTANCE
// =============================================================================

/** Instância singleton da AreaRole */
export const areaRole = new AreaRole();
